import styled from 'styled-components'
import { colors } from '@styles/vars/colors.style'

export const FieldContainer = styled.div`
`

export const RadioContainer = styled.div`
	position: relative;
	margin-bottom: 8px;
`

export const RadioTick = styled.span`
	width: 24px;
	height: 24px;
	position: absolute;
	left: 0;
	top: 0;
	&:before {
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		border: 0.1rem solid currentColor;
		opacity: 0.3;
	}
	&:after {
		content: "";
		width: calc(100% - 6px);
		height: calc(100% - 6px);
		background-color: currentColor;
		position: absolute;
		left: 3px;
		top: 3px;
		opacity: 0;
		transition: all 0.25s ease;
	}
`
export const RadioLabel = styled.p`
	position: relative;
	padding-left: 40px;
	line-height: 23px;
	z-index: 2;
	pointer-events: none;
	a {
		pointer-events: all;
	}
	p {
		font-size: 18px !important;
	}
`

export const Title = styled.p`
	margin-bottom: 8px;
`

export const SubTitle = styled.p`
	color: #AAAAAA;
`

export const InputRadio = styled.input`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	opacity: 0;
	z-index: 1;
	cursor: pointer;
	&:checked + .tick:after{
		opacity: 1;
	}
`